import axios from "axios";

// Runtime config takes priority (set by docker-entrypoint.sh from the
// container's own env vars, in public/env-config.js), falling back to
// build-time process.env for local development via `npm start`. This
// lets one built Docker image be reused across dev/stage/prod - each
// container just needs its own env vars, no rebuild required.
const runtimeEnv = (typeof window !== "undefined" && window._env_) || {};

export const APP_BASE_URL =
  runtimeEnv.REACT_APP_BASE_URL || process.env.REACT_APP_BASE_URL;
export const APP_API_BASE_URL =
  runtimeEnv.REACT_APP_API_BASE_URL || process.env.REACT_APP_API_BASE_URL;
export const REACT_APP_OLD_API_BASE_URL =
  runtimeEnv.REACT_APP_OLD_API_BASE_URL || process.env.REACT_APP_OLD_API_BASE_URL;
export const ASSETS_BASE_URL = REACT_APP_OLD_API_BASE_URL;

export default axios.create({
  baseURL: APP_API_BASE_URL,
});

export const axiosOld = axios.create({
  baseURL: REACT_APP_OLD_API_BASE_URL,
  headers: { "Content-Type": "application/json" },
});

export const axiosPrivate = axios.create({
  baseURL: APP_API_BASE_URL,
  headers: { "Content-Type": "application/json" },
  withCredentials: true,
});
